
























































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { State, Action, namespace } from 'vuex-class'
import StudyPlanToday from './studyplan/today.vue'
import MyAllCourse from './my_all_course.vue'
import College from './college.vue'
import PageRight from './page_right.vue'
import MyTopicGroup from '@/apps/ice/pages/user/components/myTopicGroup.vue'
import HotArticle from '@/apps/ice/pages/user/components/hot_article.vue'
import StudyPlanAll from './studyplan/allplan.vue'
import { Authority } from '@/apps/ice/model/authority'
import Spinner from '@/components/Spinner.vue'

const ModuleProduct = namespace('app-ice/product')
const ModuleUser = namespace('app-ice/user')
const ModuleStudyPlan = namespace('app-ice/studyPlan')

@Component({
  components: {
    StudyPlanAll,
    StudyPlanToday,
    MyAllCourse,
    College,
    PageRight,
    MyTopicGroup,
    HotArticle,
    Spinner
  }
})
export default class Main extends Vue {
  @ModuleProduct.State(state => state.collegeList)
  private collegeList?: any[]
  @ModuleProduct.Action('fetchCollegeProducts')
  fetchCollegeProducts!: Function
  @ModuleProduct.Action('fetchOrderInfo')
  fetchOrderInfo!: Function

  @ModuleUser.Action('checkAuthority')
  checkAuthority!: Function
  @ModuleUser.State(state => state.authority)
  private authority?: Authority
  @ModuleUser.Action('handleMyLearn')
  handleMyLearn!: Function
  @ModuleUser.Action('getMyLearn')
  getMyLearn!: Function

  @ModuleStudyPlan.Action('fetchAllPlan')
  private fetchAllPlan!: Function
  @ModuleStudyPlan.Action('fetchMyDayPlan')
  private fetchMyDayPlan!: Function
  @ModuleStudyPlan.Action('fetchMyClass')
  private fetchMyClass!: Function
  @ModuleStudyPlan.Action('fetchMood')
  private fetchMood!: Function

  private showTopic: boolean = false
  tabIndex: number = 0
  Authority: any = Authority

  async mounted() {
    await this.fetchOrderInfo()
    await this.getMyLearn()
    await this.fetchMyClass()
    await this.checkAuthority()
  }

  @Watch('authority')
  async authorityConfirmed(value: Authority, oldValue: Authority) {
    if (value !== undefined && oldValue === undefined) {
      if (this.authority === Authority.COLLEGE) {
        await this.loadCollegeProducts()
      }
      if (this.authority === Authority.JOB) {
        await Promise.all([
          this.fetchMyDayPlan(),
          this.fetchAllPlan(),
        ])
        await this.fetchMood()
        return
      }
      this.handleMyLearn()
    }
  }

  async loadCollegeProducts() {
    await this.fetchCollegeProducts()
  }
}
